import {RdsDateFormats} from "@rds/angular-components";

export class DateFormatter {
  presentationDate: string;

  constructor(date: string | Date, withUTC = true){
    if(!(date instanceof Date)){
      date = new Date(date);
    }
    this.presentationDate = this.formatDate(date)
    if(!withUTC)
      this.presentationDate = this.presentationDate.split(',')[0]
  }

  private formatDate(date: Date | undefined): string {
    if(!date)
      return ""
    const day = this.partFormatter(date, {day: '2-digit'})
    const month = this.partFormatter(date, {month: 'short'})
    const year = this.partFormatter(date, {year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'})
    return `${day} ${month} ${year} UTC`
  }

  private partFormatter(date: Date,  part: Intl.DateTimeFormatOptions | undefined){
    return date.toLocaleString('en-US', {
      timeZone: 'UTC',
      ...part
    })
  }

  static getDatePickerFormat(): RdsDateFormats{
    return {
      parse: {
        dateInput: (d: string) => d.replace(" ", "-"),
      },
      display: {
        dateInput: {
          year: "numeric",
          month: "short",
          day: "2-digit",
        },
        monthYearLabel: { year: "numeric", month: "short" },
        dateA11yLabel: { year: "numeric", month: "long", day: "numeric" },
        monthYearA11yLabel: { year: "numeric", month: "long" },
      },
    };
  }
}
